import m from 'mithril'

import VideoIcon from './VideoIcon'
import DocumentIcon from './DocumentIcon'

export default {
  view: vnode => {
    const style = { width: '150px', height: '150px', ...(vnode.attrs.hotspot.style || {}) }
    const text = vnode.attrs.hotspot.text
    const icon = vnode.attrs.hotspot.icon
    const labelOffset = vnode.attrs.hotspot.labelOffset || 0
    const horizontalLabelOffset = vnode.attrs.hotspot.horizontalLabelOffset || 0
    const labelClasses = vnode.attrs.hotspot.labelClasses || ''
    const path = vnode.attrs.hotspot.path

    return (
      <article
        className={`hotspot-inner hotspot-popup mod-${vnode.attrs.hotspot.id}`}
        style={style}
      >
        {text && (
          <div
            className={`hotspot-popup-info u-hotspot-fade ${labelClasses}`}
            style={{ top: `${labelOffset}px`, left: `${horizontalLabelOffset}px` }}
            onclick={() => m.route.set(path)}
          >
            {/* {texture && <img src={texture} className="hotspot-info-texture" />} */}
            <div className="hotspot-flex-container">
              {icon === 'video' ? <VideoIcon /> : <DocumentIcon />}
              {text && <p className="hotspot-popup-info-text">{m.trust(text)}</p>}
            </div>
          </div>
        )}
      </article>
    )
  }
}
